package org.matthewo.recharts.type

object ComponentPosition {

    val top: ComponentPosition
        get() = "top".unsafeCast<ComponentPosition>()

    val left: ComponentPosition
        get() = "left".unsafeCast<ComponentPosition>()

    val right: ComponentPosition
        get() = "right".unsafeCast<ComponentPosition>()

    val bottom: ComponentPosition
        get() = "bottom".unsafeCast<ComponentPosition>()

    val inside: ComponentPosition
        get() = "inside".unsafeCast<ComponentPosition>()

    val outside: ComponentPosition
        get() = "outside".unsafeCast<ComponentPosition>()

    val insideLeft: ComponentPosition
        get() = "insideLeft".unsafeCast<ComponentPosition>()

    val insideRight: ComponentPosition
        get() = "insideRight".unsafeCast<ComponentPosition>()

    val insideTop: ComponentPosition
        get() = "insideTop".unsafeCast<ComponentPosition>()

    val insideBottom: ComponentPosition
        get() = "insideBottom".unsafeCast<ComponentPosition>()

    val insideTopLeft: ComponentPosition
        get() = "insideTopLeft".unsafeCast<ComponentPosition>()

    val insideBottomLeft: ComponentPosition
        get() = "insideBottomLeft".unsafeCast<ComponentPosition>()

    val insideTopRight: ComponentPosition
        get() = "insideTopRight".unsafeCast<ComponentPosition>()

    val insideBottomRight: ComponentPosition
        get() = "insideBottomRight".unsafeCast<ComponentPosition>()

    val insideStart: ComponentPosition
        get() = "insideStart".unsafeCast<ComponentPosition>()

    val insideEnd: ComponentPosition
        get() = "insideEnd".unsafeCast<ComponentPosition>()

    val end: ComponentPosition
        get() = "end".unsafeCast<ComponentPosition>()

    val center: ComponentPosition
        get() = "center".unsafeCast<ComponentPosition>()
}
